import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'noZero' })
export class NoZeroPipe implements PipeTransform {

constructor() {}

    transform(price: string): string {
        if (price === '0,00 €') {
            return 'Consultar';
        } else {
            return price;
        }
    }
}
